/**
 * Whether a dialog holds input that leaving would discard (#591). Each dialog passes the answer to
 * `useUnsavedWork`, so a room switch — or the section nav, or closing the tab — asks first, as the
 * template, points and salary editors already do. A dialog's own Cancel is the operator choosing to
 * discard, and does not ask. `dialogDrafts.test.js` sweeps every room-web component rendering a `Modal`.
 *
 * The guard holds ONE flag, so two holders mounted at once can clear each other. No dialog registered here
 * opens over another holder that can be dirty; one that would must not register on its own.
 */

/**
 * A form is unsaved once its fields differ from where the dialog opened them. Compared by content, so a
 * re-render that rebuilds an equal draft is not a change.
 */
export function changedFrom(baseline: unknown, current: unknown): boolean {
  return JSON.stringify(baseline) !== JSON.stringify(current);
}

/** An import is unsaved from the moment a file is chosen until it has an outcome. */
export function importUnfinished(state: { file: unknown; outcome: unknown }): boolean {
  return state.file !== null && state.outcome === null;
}
